/**
 * Canonical list of permission IDs used for role-based access.
 * Must stay in sync with Firestore rules and Cloud Functions.
 */
export const ALL_PERMISSIONS = [
  'appointments:manage',
  'appointmentRequests:manage',
  'clients:create',
  'clients:manage',
  'users:manage',
  'roles:manage',
  'services:manage',
  'paymentMethods:manage',
  'inventory:manage',
  'reports:read',
  'bankTransactions:manage',
  //'reports:run',
];

/** Human-readable labels for permissions (optional). */
export const PERMISSION_LABELS = {
  'appointments:manage': 'Gerenciar todos os agendamentos',
  'appointmentRequests:manage': 'Gerenciar solicitações de agendamento',
  'clients:create': 'Criar clientes',
  'clients:manage': 'Gerenciar clientes',
  'users:manage': 'Gerenciar equipe (serviços e horários)',
  'roles:manage': 'Gerenciar perfis',
  'services:manage': 'Gerenciar serviços',
  'paymentMethods:manage': 'Gerenciar formas de pagamento',
  'inventory:manage': 'Gerenciar estoque',
  'reports:read': 'Ver relatórios',
  'bankTransactions:manage': 'Gerenciar financeiro',
  //'reports:run': 'Executar atualização de dados do relatório',
};
